import { Box, Flex, useToken } from "@chakra-ui/react";
import { Lottie } from "src/components/Lottie";
import { BodyText2 } from "src/atoms/typography";
import {
  dressColors,
  accessories
} from "src/modules/avatar/baby-customization";
import Field from "../Field";
import { ReactComponent as NoneIcon } from "../../icons/none.svg";

import BEAR_CAP from "./animatinos/BearCap.json";
import BOW from "./animatinos/Bow.json";
import CAP from "./animatinos/Cap.json";
import FROG_CAP from "./animatinos/FrogCap.json";
import HEADDRESS from "./animatinos/Hairdress.json";

const accessoriesAnimations = { BOW, CAP, HEADDRESS, FROG_CAP, BEAR_CAP };

export default function Accessories({ avatar, handleAvatarStyleUpdate, t }) {
  const surfaceElevated1 = useToken("colors", "surfaceElevated1");
  const primary = useToken("colors", "primary");

  const { avatarCustomization } = avatar;
  const { accessoryColor, accessory } = avatarCustomization;
  const disableColors =
    !accessory ||
    accessory?.includes("FROG") ||
    accessory?.includes("BEAR") ||
    accessory === "NO_ACCESSORY";
  const colorCss = Object.values(accessories).reduce((result, layers) => {
    layers.forEach((layer) => {
      if (
        layer.includes("Base") &&
        !layer.includes("Bear") &&
        !layer.includes("Frog")
      ) {
        result =
          result +
          `
& .${layer} {
  fill: ${accessoryColor};
}
`;
      }
    });
    return result;
  }, "");
  return (
    <Box py="16px" overflow="auto" height="100%" maxHeight="317px">
      <BodyText2 mb="8px" color="highEmphasis">
        {t("avatar.accessoriesType")}
      </BodyText2>
      <Flex
        mb="16px"
        flexWrap="wrap"
        gap="14px"
        css={`
          ${colorCss}
        `}
      >
        <Field
          onClick={() => handleAvatarStyleUpdate({ accessory: "NO_ACCESSORY" })}
          isSelected={accessory === "NO_ACCESSORY"}
        >
          <Box sx={{ svg: { fill: "rgba(0, 0, 0, 0.54)" } }}>
            <NoneIcon height="20px" width="20px" />
          </Box>
        </Field>
        {Object.entries(accessoriesAnimations).map(([key, animation]) => {
          return (
            <Field
              key={key}
              onClick={() => handleAvatarStyleUpdate({ accessory: key })}
              isSelected={key === accessory}
            >
              <Lottie
                animationData={animation}
                widht="42px"
                height="42px"
                browserProps={{ hasRawData: true }}
              />
            </Field>
          );
        })}
      </Flex>
      <Box
        transition="all 0.3s"
        minHeight={disableColors ? "0px" : "60px"}
        maxHeight={disableColors ? "0px" : "100%"}
        opacity={disableColors ? 0 : 1}
        zIndex={disableColors ? -10 : 0}
      >
        <BodyText2 mb="8px" color="highEmphasis">
          {t("avatar.accessoriesStyle")}
        </BodyText2>

        <Flex ml="5px" flexWrap="wrap" gap="12px">
          {dressColors.map((color) => {
            return (
              <Box
                onClick={() =>
                  handleAvatarStyleUpdate({ accessoryColor: color })
                }
                key={color}
                width="32px"
                bg={color}
                height="32px"
                borderRadius="100%"
                {...(color === accessoryColor && {
                  boxShadow: `0 0 0 2pt ${surfaceElevated1},0 0 0 4pt ${primary}`
                })}
              />
            );
          })}
        </Flex>
      </Box>
    </Box>
  );
}
